import { StateCreator } from 'zustand';

import { State } from './types';

export const stateCreator: StateCreator<State> = (set): State => ({
  redirectUrl: null,
  setRedirectUrl: (redirectUrl) => set({ redirectUrl }),
  clearRedirectUrl: () => set({ redirectUrl: null }),
});
